module.exports = __webpack_public_path__ + "static/media/icon-error.ef170ab2.svg";